import React from "react";
import { Filter, Loading, ToggleSwitch } from "..";
import { useGetRegistries } from "modules/common/hooks/dippHooks";
import { classNames } from "helpers/ClassNameHelper";

interface Props {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onClear: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
    isActive: boolean;
    showDropdown: boolean;
    value: string[];
}

export const RegistryFilter: React.FC<Props> = ({
    onChange,
    onClick,
    onClear,
    isActive,
    showDropdown,
    value,
}) => {
    const { data: registries, isFetching: isLoading } = useGetRegistries();

    const renderFilter = () => {
        if (isLoading) return <Loading size="small" />;

        if (registries?.length)
            return registries?.map(registry => (
                <div key={registry.name}>
                    <ToggleSwitch
                        value={registry.name}
                        checked={value.includes(registry.name)}
                        onChange={onChange}
                        htmlFor={registry.name}
                        text={
                            <div
                                className={classNames(
                                    "filter__item__text",
                                    registry.parentId !== null && "ml-16"
                                )}
                            >
                                {registry.name?.toLocaleUpperCase()}
                            </div>
                        }
                    />
                </div>
            ));

        return <p>Nema podataka</p>;
    };

    return (
        <Filter
            isActive={isActive}
            showDropdown={showDropdown}
            onClear={onClear}
            onClick={onClick}
            text="KATEGORIJA"
        >
            {renderFilter()}
        </Filter>
    );
};
